@if (editQuestionData) {
  <mat-card>
    <mat-card-header>
      <mat-card-title> {{ (cwQuestion._id ? 'titles.update-question' : 'titles.create-question') | translate }}</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <app-edit-question [editQuestionData]="editQuestionData" [canDeactivate]="canEditCreateQuestionDeactivate"></app-edit-question>
    </mat-card-content>
  </mat-card>
}
